import { useEffect, useState } from 'react';

/**
 * Simple navigator.onLine wrapper + event listeners. `offline` events fire
 * reliably; `online` events fire when we regain connectivity. We also poll
 * every 20 s as a belt-and-suspenders check because some Safari versions
 * lie about the event.
 */
export function useOnlineStatus(): boolean {
  const [online, setOnline] = useState(typeof navigator === 'undefined' ? true : navigator.onLine);

  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    const tick = setInterval(() => setOnline(navigator.onLine), 20_000);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
      clearInterval(tick);
    };
  }, []);

  return online;
}
